import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { applyCachedBrand, ionicBrandVars } from '@crewdle/white-label';

import { AppModule } from './app/app.module';
import { canonicalHostRedirect } from './app/utils/canonical-host';
import { environment } from './environments/environment';

// connect.* → app.* (2026-10-07): move the tab before anything boots.
const canonicalUrl = canonicalHostRedirect(window as unknown as Parameters<typeof canonicalHostRedirect>[0]);
if (canonicalUrl) {
  window.location.replace(canonicalUrl);
} else {
  bootstrap();
}

function bootstrap(): void {
    if (environment.production) {
    enableProdMode();
  }

  // Re-apply the last-known partner brand from localStorage before Angular
  // renders anything, so branded users don't see a flash of Crewdle defaults.
  // The live Firestore read then confirms or replaces it. ionicBrandVars maps
  // the brand onto this app's Ionic theme variables (see WHITE_LABEL_CONFIG).
  applyCachedBrand({ extraVars: ionicBrandVars });

  platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch(err => console.error(err));
}
